import React from 'react'

import { TextLink } from '@octane/spark'
import { FinePrint } from 'containers/Authentication/AuthenticationFormBuilder.styled'
import { SUPPORT_PHONE } from 'utils/consts/contactInfo'
import { toTelHref } from 'utils/formatPhoneNumber'

type LoginFinePrintProps = {
    readonly onTermsOfUseClick: () => void
}

export default function LoginFinePrint({
    onTermsOfUseClick,
}: LoginFinePrintProps): JSX.Element {
    return (
        <>
            <FinePrint>
                <div>
                    Need help? Call us at{' '}
                    <TextLink as="span">
                        <a href={toTelHref(SUPPORT_PHONE)}>{SUPPORT_PHONE}</a>
                    </TextLink>{' '}
                    or email us at{' '}
                    <TextLink as="span">
                        <a href="mailto:support@octanelending.com">
                            support@octanelending.com
                        </a>
                    </TextLink>
                </div>
            </FinePrint>
            <FinePrint>
                <div>
                    Our{' '}
                    <TextLink as="span">
                        <button
                            type="button"
                            data-testid="termsOfUseButton"
                            onClick={() => onTermsOfUseClick()}
                        >
                            Terms of Use
                        </button>
                    </TextLink>{' '}
                    apply.
                </div>
            </FinePrint>
        </>
    )
}
